import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "children"];
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Tab } from '@ariakit/react';
import clsx from 'clsx';
import { forwardRef, useRef } from 'react';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.js';
import { useForkRef } from '../../utils/useForkRef.js';
import styles from './tabs.module.js';
import { useTabs } from './use-tabs.js';
var outlineWidth = 3;
var outlineOffset = 1;
var padding = 12;

var scrollTabIntoViewIfSelected = function scrollTabIntoViewIfSelected(tabRef, isSelected) {
  var _tabRef$current;

  var tabElement = tabRef.current;
  var tabParentElement = (_tabRef$current = tabRef.current) === null || _tabRef$current === void 0 ? void 0 : _tabRef$current.parentElement;
  var scrollOffset = outlineWidth + outlineOffset + padding;

  if (!isSelected || !tabElement || !tabParentElement) {
    return;
  }

  var scrollHorizontalPosition = tabElement.getBoundingClientRect().left - scrollOffset;
  tabParentElement.scrollLeft = scrollHorizontalPosition;
};

var DefaultTab = /*#__PURE__*/forwardRef(function Tab$1(props, ref) {
  var _useTabs;

  var className = props.className,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var tabRef = useRef(null);
  var selectedTabId = (_useTabs = useTabs()) === null || _useTabs === void 0 ? void 0 : _useTabs.useState('selectedId');
  var isTabSelected = selectedTabId === (rest === null || rest === void 0 ? void 0 : rest.id);
  var checkedScrollOnMount = useRef(false);
  useEnhancedEffect(function () {
    if (checkedScrollOnMount.current) {
      return;
    }

    scrollTabIntoViewIfSelected(tabRef, isTabSelected);
    checkedScrollOnMount.current = true;
  }, [isTabSelected]);
  return jsxs(Fragment, {
    children: [jsxs(Tab, _objectSpread(_objectSpread({}, rest), {}, {
      ref: useForkRef(tabRef, ref),
      className: clsx(styles.tab, className),
      children: [children, jsx("span", {
        className: styles.hiddenWidthSetter,
        children: children
      })]
    })), jsx("div", {
      "aria-hidden": "true",
      className: styles.tabSeparator,
      role: "presentation"
    })]
  });
});
DefaultTab.displayName = 'DefaultTab';
export { DefaultTab };